import React from 'react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__copy">© {new Date().getFullYear()} Mahad Rehan</p>
        <nav className="site-footer__nav" aria-label="Footer links">
          <a href="https://github.com/mahaaad" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a href="https://www.linkedin.com/in/mahadrehan/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <a href="mailto:mahad.rehan@gmail.com">Email</a>
        </nav>
      </div>
    </footer>
  );
}
